import { Trans } from "@lingui/macro";
import { ListFilter } from "lucide-react";

/**
 * Says why a patient list is shorter than the reader's pool: it follows the dashboard's selection
 * (PT-148). Without it, a name searched outside the selection would simply look missing.
 */
export function SelectionFilterHint() {
  return (
    <div className="flex items-center gap-1.5 border-b border-slate-100 px-3 py-1.5 text-2xs text-slate-500">
      <ListFilter className="h-3 w-3 shrink-0 text-primary" />
      <span className="truncate">
        <Trans>Patients de la sélection du tableau de bord</Trans>
      </span>
    </div>
  );
}
